import { useState, useEffect, useCallback } from "react";
import Config from "../pages/Config";

export function useRefAgent() {
  const [Ref, setRef] = useState(null);
  const [Agent, setAgent] = useState(null);
  const [RefLoading, setRefLoading] = useState(true);
  const [Refresh, setRefresh] = useState(0);
  
  useEffect(()=>{
    const ref = localStorage.getItem("refid") || null;
    const agent = localStorage.getItem("agentid") || null;
    const refParam = ref?ref:"";
    const agentParam = agent?agent:"";
    setRef(null);
    setAgent(null);
    let isActive = true;
    const fetchRef = async()=>{
      try{
        const res = await fetch(Config.NodePath+"/api/ref?refId="+refParam+"&agentId="+agentParam);
        if(!isActive) return;
        if(res.ok) {
          const data = await res.json();
          setRef(data.ref || false);
          setAgent(data.agent || false);
        }
      }
      catch(err) {
        console.log(err);
      }
      finally{
        setRefLoading(false);
      }
    }
    fetchRef();

    return ()=>{
      isActive=false;
    }
  }, [Refresh]);
  return {Ref, Agent, RefLoading, RefreshAgent : useCallback(() =>setRefresh(prev=>prev+1), [])};
}